import { useTimestamp } from '@vueuse/core';

export default () => {
  const propertyOf = <TObj>(name: keyof TObj) => name as string;

  const generateUniqueNumber = (): string => {
    const timestamp = useTimestamp();
    return (timestamp.value + Math.floor(Math.random() * 1000)).toString();
  };

  return {
    propertyOf,
    generateUniqueNumber,
  };
};
